import {OnInit,AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {HeaderEnum, RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {AsignacionEvaluacionColaboradorComponent} from "./asignacioncolaborador/asignacionevaluacioncolaborador.component";
import {AsignacionEvaluacionAlmunosComponent} from "./asignacionalumnos/asignacionevaluacionalumno.component";
import {AsignacionEvaluacionPadresComponent} from "./asignacionevaluacionpadres/asignacionevaluacionpadres.component";
import { AsignacionEvaluacionTallerComponent } from "./asignacionevaluaciontalleres/asignacionevaluaciontaller.component";
import { AlertaEnum, DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";

@Component({
    selector: 'asignacionevaluaciondetalle',
    templateUrl: './asignacionevaluaciondetalle.component.html',
    styleUrls: ['./asignacionevaluacion.component.scss']
})

export class AsignacionEValuacionDetalleComponent implements OnInit, AfterViewInit {
    entidad: PeriodoEvaluacion;
    cambio: boolean = false;
    public animacion!: string;
    public abierto!: boolean;
    @Input() accion!: {accionid: number, accion: string};
    @Input() entidadperiodo!: any;
    @Output() output = new EventEmitter();
    consulta!: boolean;

    SelDataPeriodoporTipo: any[];
    SelColaborador: any[];
    selectedRows:any[];
    public errorActivo!: boolean;
    jeferesponsable: number = 0;
    firmaresponsable: number = 0;

    firmados: any[] = [];

    @ViewChild("asignacionevaluacionevaluaciones", {read: ViewContainerRef}) asignacionevaluacionevaluaciones!: ViewContainerRef;

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.entidad = new PeriodoEvaluacion();
        this.SelDataPeriodoporTipo = [];
        this.SelColaborador = [];
        this.selectedRows = [];
    }

    ngOnInit() {
        this.entidad = new PeriodoEvaluacion(this.entidadperiodo);
        this.entidad.fechainicioperiodo = this.formatDate(this.entidad.fechainicioperiodo)
        this.entidad.fechainicioacuerdos = this.formatDate(this.entidad.fechainicioacuerdos)
        this.entidad.fechafinacuerdos = this.formatDate(this.entidad.fechafinacuerdos)

    }
    ngAfterViewInit() {
        if(this.accion.accionid == 1){
            this.SetPeriodoporTipo(this.entidadperiodo.periodoevaluacionid);
        }else{
            this.SetInfoColaborador();
        }
    }

    SetInfoColaborador(){
        this.appService.Post("acuerdo/asignacion/colaboradoracuerdo",{"entidad":this.entidad}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.SelColaborador = res.data;
            }
        })
    }

    SetPeriodoporTipo(id: number) {
        this.appService.Post("planeacion/periodoevaluacion/periodoevaluacionportipoevaluacion", {"periodoevaluacionid": id, "periodoevaluacionfiltroid": id}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                for (let datos of res.data) {
                    datos.fechainicioevaluacion = new Date(datos.fechainicioevaluacion + "T00:00:00")
                }
                if(this.sistemaService.permisos.edicionespecial){
                  this.SelDataPeriodoporTipo = res.data
                }else{
                  let datos = res.data.filter((x: any) => x.tipoevaluacionid == 1);
                  this.SelDataPeriodoporTipo = datos;
                }
            }
        })
    }

    Formulario(e: any, identificador: number) {
        let accion: string = ""
        switch (e.tipoevaluacionid) {
            case 1:
                accion = e.nombre;
                this.cargarContenedorFormularioColaborador({accion: accion, entidad: e, identificador: identificador})
                break;
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                accion = e.nombre;
                this.cargarContenedorFormularioAlumons({accion: accion, entidad: e, identificador: identificador});
                break;
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                accion = e.nombre;
                this.cargarContenedorFormularioPadres({accion: accion, entidad: e, identificador: identificador});
                break;
            case 12:
            case 13:
            case 14:
            case 15:
                accion = e.nombre;
                this.cargarContenedorFormularioTaller({accion: accion, entidad: e, identificador: identificador});
                break;
            case 16:
                accion = e.nombre;
                break;
        }
    }

    cargarContenedorFormularioColaborador(data: {accion: string, entidad: any, identificador: number}) {
        this.consulta = true;
        this.asignacionevaluacionevaluaciones.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AsignacionEvaluacionColaboradorComponent);
        var ref: ComponentRef<any> = this.asignacionevaluacionevaluaciones.createComponent(factory);
        ref.instance.id = this.entidadperiodo.periodoevaluacionid;
        ref.instance.accion = {accion: data.accion, entidad: data.entidad};
        ref.instance.identificador = data.identificador;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }

    cargarContenedorFormularioAlumons(data: {accion: string, entidad: any, identificador: number}) {
        this.consulta = true;
        this.asignacionevaluacionevaluaciones.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AsignacionEvaluacionAlmunosComponent);
        var ref: ComponentRef<any> = this.asignacionevaluacionevaluaciones.createComponent(factory);
        ref.instance.id = this.entidadperiodo.periodoevaluacionid;
        ref.instance.accion = {accion: data.accion, entidad: data.entidad};
        ref.instance.identificador = data.identificador;
        ref.instance.cicloid = this.entidad.cicloid;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }

    cargarContenedorFormularioPadres(data: {accion: string, entidad: any, identificador: number}) {
        this.consulta = true;
        this.asignacionevaluacionevaluaciones.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AsignacionEvaluacionPadresComponent);
        var ref: ComponentRef<any> = this.asignacionevaluacionevaluaciones.createComponent(factory);
        ref.instance.id = this.entidadperiodo.periodoevaluacionid;
        ref.instance.accion = {accion: data.accion, entidad: data.entidad};
        ref.instance.identificador = data.identificador;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }

    cargarContenedorFormularioTaller(data: {accion: string, entidad: any, identificador: number}) {
        this.consulta = true;
        this.asignacionevaluacionevaluaciones.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AsignacionEvaluacionTallerComponent);
        var ref: ComponentRef<any> = this.asignacionevaluacionevaluaciones.createComponent(factory);
        ref.instance.id = this.entidadperiodo.periodoevaluacionid;
        ref.instance.accion = {accion: data.accion, entidad: data.entidad};
        ref.instance.identificador = data.identificador;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
        });
    }

    Guardar() {
      let responsable = this.selectedRows.find(x=>x.puestoporcolaboradorjefe == this.jeferesponsable);
      if(responsable && this.firmaresponsable > 0){
        this.appService.Post("acuerdo/asignacion/guardarresponsable",{"listaacuerdos":this.selectedRows, "responsable": responsable, "firma":this.firmaresponsable}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.CerrarModal();
              this.SetInfoColaborador();
              this.jeferesponsable = 0;
          }
        })
      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar un reponsable para agrupar los acuerdos o la firma");
      }
    }

    GuardarResponsable(){
      let responsable = this.selectedRows.find(x=>x.puestoporcolaboradorjefe == this.jeferesponsable);
      if(responsable){
        this.appService.Post("acuerdo/asignacion/guardarresponsable",{"listaacuerdos":this.selectedRows, "responsable": responsable}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.CerrarModal();
              this.SetInfoColaborador();
              this.jeferesponsable = 0;
          }
        })
      }else{
        this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar un reponsable para agrupar los acuerdos");
      }
    }

    AgruparAcuerdos(){
        this.selectedRows = this.SelColaborador.filter(x=> x.seleccion);
         let info = this.selectedRows.map(item => item.asignacionacuerdofirmaid).filter((value, index, self) => self.indexOf(value) === index && value != null);
         this.firmados = this.selectedRows.filter(item=>{
          for(let data of info){
            if(item.asignacionacuerdofirmaid == data){
              return item
            }}});
        if(this.selectedRows.length >= 2){
            let error = this.validaciones(1);
            let errorpordesactivo = this.validaciones(2);
            if(error && errorpordesactivo){
              if(this.firmados.length > 0){
                let opciones = this.sistemaService.GetOpcionesConfirmar();
                this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia <br> Se tiene seleccionado minimo un acuerdo ya firmado para ser agrupado. <br> Esta accion puede ocacionar que las firmas de los otros acuerdos sean eliminadas. <br> ¿Desea continuar?', opciones).then(res => {
                    if (res == 1) {
                      this.Modal();
                    }
                })
              }else{
                this.Modal();
              }
            }
        }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar mínimo dos acuerdos para agrupar")
        }
    }

    validaciones(tipovalidacion:number):any{
      let validado = false;
      let central = this.selectedRows[0];
      switch(tipovalidacion){
        case 1:
          let error = this.selectedRows.find(x=> x.colaboradorevaluador != central.colaboradorevaluador);
          if(error){
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene seleccionado un acuerdo que no se puede agrupar")
          }else{
            validado = true;
          }
          break;
        case 2:
          let errorpordesactivo = this.selectedRows.find(x=> !x.activo);
          if(errorpordesactivo){
              this.mensajeService.Alerta(AlertaEnum.Warning, "Se esta agrupando minimo un acuerdo desactivado")
          }else{
            validado = true;
          }
          break;
        case 3:
          let errorpordesactivoagrupado = this.selectedRows.find(x=> !x.activo || !x.asignacionacuerdoresponsableid);
            if(errorpordesactivoagrupado){
                this.mensajeService.Alerta(AlertaEnum.Warning, "Se esta agrupando minimo un acuerdo desactivado o un acuerdo no agrupado")
            }else{
              validado = true;
            }
            break;
        case 4:
          let concuerdan = this.selectedRows.find(x=> x.asignacionacuerdoresponsableid != central.asignacionacuerdoresponsableid);
          if(concuerdan){
              this.mensajeService.Alerta(AlertaEnum.Warning, "Los acuerdos agrupados no son de la misma agrupacion")
          }else{
            validado = true;
          }
          break;
        case 5:
          let total = this.SelColaborador.filter(x=>x.asignacionacuerdoresponsableid == central.asignacionacuerdoresponsableid);
          if(total.length != this.selectedRows.length){
            this.mensajeService.Alerta(AlertaEnum.Warning, "No se seleccionaron todos los acuerdos de esta agrupacion")
          }else{
            validado = true;
          }
          break;
      }
      return validado
    }

    DesagruparAcuerdos(){
        this.selectedRows = this.SelColaborador.filter(x=> x.seleccion)
        if(this.selectedRows.length >= 2){
            let error =  this.validaciones(1);
            let errorpordesactivo = this.validaciones(3);
            let concuerdan = this.validaciones(4);
            let cantidad = this.validaciones(5);
            if(error && errorpordesactivo && concuerdan && cantidad){
                this.quitaragrupadas();
            }
        }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar mínimo dos acuerdos para desagrupar")
        }
    }

    quitaragrupadas(){
      let firmada = this.selectedRows.find(x=> x.asignacionacuerdofirmaid);
      if(firmada){
        let opciones = this.sistemaService.GetOpcionesConfirmar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia <br> Se intenta desagrupar acuerdos que ya fueron firmados <br> Al desagruparlos la firma se quedara solo con el responsable. <br> ¿Desea continuar?', opciones).then(res => {
            if (res == 1) {
              this.appService.Post("acuerdo/asignacion/eliminarresponsable",{"listaacuerdos":this.selectedRows}).then(res=>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.SetInfoColaborador();
                }
            })
            }
        })
      }else{
        this.appService.Post("acuerdo/asignacion/eliminarresponsable",{"listaacuerdos":this.selectedRows}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.SetInfoColaborador();
          }
      })
      }

    }

    activardesactivar(e:any, event:any){
        e.activo = event.value;
        this.appService.Post("acuerdo/asignacion/actualizaracuerdo",{'entidad':e}, [HeaderEnum.NoShowLoading]).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){

            }
        })
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
    }

    CerrarModal() {
        //this.entidad = new Criterio();
        this.animacion = this.sistemaService.animacionCerrarModal;
        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    onRowPrepared(e:any){
        if(e.rowType == "data"){
          if(e.key.asignacionacuerdoresponsableid){
            e.rowElement.bgColor = "#D9EDF8";
          }
        }
        if (e.rowType === "group" && e.groupIndex == 0) {
            let grupos:any[] = e.data.items ? e.data.items : e.data.collapsedItems;
            e.data.total = grupos.length;
            let unicos = grupos.map(item => item.asignacionacuerdoresponsableid)
            .filter((value, index, self) => self.indexOf(value) === index && value != null);
            if(unicos.length > 0){
                e.data.texto = unicos.length + " agrupación de acuerdo";
            }else{
                e.data.texto = "Ninguna agrupación";
            }


        }
    }

    formatDate(date: string) {
        let valor = date.split("/")
        let fecha = valor[2] + "-" + valor[1] + "-" + valor[0];
        return fecha;
    }

    formatBoolean = (cellInfo:any) => {
      return cellInfo.value === true ? 'Activo' : 'Desactivado';
      }

    //Salir del formulario
    Salir() {
        this.output.next(this.cambio);
    }
}
